import { render, staticRenderFns } from "./PrizesComp.vue?vue&type=template&id=516d0af8&scoped=true&"
import script from "./PrizesComp.vue?vue&type=script&lang=ts&"
export * from "./PrizesComp.vue?vue&type=script&lang=ts&"
import style0 from "./PrizesComp.vue?vue&type=style&index=0&id=516d0af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d0af8",
  null
  
)

export default component.exports